import * as React from 'react'
import RadioGroup, {RadioGroupProps} from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import styled from 'styled-components'
import RadioAtom from '../radio/radio.atom'

interface ApRadioGroupProps extends RadioGroupProps {
  label?: string
  valueDefault?: string
  valuesArr: string[]
  row?: boolean
  labelPlacement?: 'top' | 'end' | 'bottom' | 'start'
}
const apAtomName = {ap_atom_name: 'radioGroupAtom'}

const RadioGroupAtom = styled((props: ApRadioGroupProps) => {
  return (
    <FormControl component="fieldset">
      {props.label && <FormLabel component="legend">{props.label}</FormLabel>}

      <RadioGroup
        {...apAtomName}
        aria-label={props.label?.toLowerCase()}
        defaultValue={props.valueDefault}
        row={props.row}
        name="radio-buttons-group"
      >
        {props.valuesArr.map(each => {
          const eachLowercase = each.toLowerCase()
          return (
            <FormControlLabel
              key={eachLowercase}
              value={eachLowercase}
              control={<RadioAtom />}
              label={each}
            />
          )
        })}
      </RadioGroup>
    </FormControl>
  )
})``

export default RadioGroupAtom
